import {Component, OnInit} from '@angular/core';
import {CrisisAlertService} from '../services/crisis-alert.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  today: number;
  private diff: number;

  constructor(private crisisAlertService: CrisisAlertService, private title: Title) {
  }

  ngOnInit() {
    this.title.setTitle('Your Dashboard');
    this.crisisAlertService.ensureRefData();
    this.crisisAlertService.serverTimeObs.subscribe(serverTime => {
      this.today = serverTime;
      this.diff = Date.now() - serverTime;
    });
    this.crisisAlertService.searchCases(this.crisisAlertService.specialityCodeSub.getValue(),
      this.crisisAlertService.searchQuerySub.getValue());
    setInterval(() => {
      this.today = Date.now() - this.diff;
    }, 15000);
  }
}
